<template>
    <div>
        <v-row class="mt-3">
            <v-col cols="12" sm="12">
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headersTable"
                            :items="articleDiscountGroups"
                            :page="page"
                            :pageCount="numberOfPages"
                            :options.sync="options"
                            :server-items-length="totalRecords"
                            :footer-props="{
                                showFirstLastPage: true,
                                'items-per-page-options': [10, 20, 50],
                            }"
                        >
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        articleDiscountGroups: Array | Object,
        searchCount: Number,
        totalRecords: Number,
    },
    data() {
        return {
            headersTable: [
                {
                    text: this.$t(
                        "backoffice.modules-management.supplier-management.article-discount-groups.id"
                    ),
                    align: "start",
                    value: "discountGroupID",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.supplier-management.article-discount-groups.description"
                    ),
                    align: "start",
                    value: "discountGroupName",
                    class: "header-table-color",
                },
            ],
            searchState: false,
            searchText: "",

            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        };
    },
    methods: {
        openSearchAdvanced() {
            this.searchState = !this.searchState;
        },
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
        deep: true,
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.article-span {
    font-size: 22px;
}
.row-search {
    &::before {
        content: " ";
        height: 1px;
        width: 100%;
        position: absolute;
        background-color: #d6d6d6;
        bottom: 0;
        left: 0;
    }
}
.search {
    .v-input__control {
        .v-input__slot {
            margin-bottom: 0px !important;
            &::before {
                border: 0 !important;
            }
            label {
                font-size: 12px;
                color: #9e9d9d;
            }
        }
    }
    .v-text-field__details {
        min-height: 0px;
        display: none;
    }
}

.buttonAdvanced {
    font-size: 12px !important;
    text-transform: capitalize !important;
    color: #9e9d9d !important;

    &:hover {
        color: var(--v-primary-base) !important;
        path {
            fill: var(--v-primary-base);
        }
        &:before {
            background-color: transparent !important;
        }
    }
    &:focus {
        &:before {
            background-color: transparent !important;
        }
    }
    &.active {
        color: var(--v-primary-base) !important;
        path {
            fill: var(--v-primary-base);
        }
    }
}

.filter-advenced {
    .v-subheader {
        font-size: 12px;
        color: #9e9d9d;
    }
    .v-select__selection {
        font-size: 12px;
    }
    .v-input__slot {
        font-size: 12px;
        label {
            font-size: 12px;
        }
    }
}
.reset-span {
    color: $grey;
    text-align: left;
    font-size: 16px;
    letter-spacing: 0px;
    color: $grey;
    opacity: 1;
    cursor: pointer;
}
</style>
